<template>
  <div>
    <!-- <div>
            <el-row :gutter="12" style="margin: 0 auto">
                <el-col :span="12">
                    <el-page-header @back="goBack" />
                </el-col>
            </el-row>
        </div> -->
    <!-- <div style="
          width: 100%;
          text-align: center;
          font-size: 35px;font-weight: bold;
        ">
            校史馆参观预约详情
        </div> -->
    <div
      style="justify-content: center"
    >
      <div
        style="
          margin-top: 10px;
          justify-content: center;
          margin-left: 5%;
          margin-right: 5%;
          border-bottom: 1px solid #a0cc97;
          border-right: 1px solid #a0cc97;
        "
        v-if="!!detaile.amusername"
      >
        <el-row justify="center" align="middle" style="">
          <el-col :span="2">
            <div class="trcol">预约人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ detaile.amusername }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ detaile.amuserid }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ detaile.amuserdepartname }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">
              {{ detaile.amusermajor != null ? detaile.amusermajor : " " }}
            </div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">
              {{ detaile.amuserclass != null ? detaile.amuserclass : " " }}
            </div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">手机号码</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ detaile.amusertel }}</div>
          </el-col>
        </el-row>
      </div>
      <!-- <div style="margin-top: 30px;justify-content: center;margin-left: 20%;margin-right: 5%;">
                <el-steps :space="600" :active="active" finish-status="success" align-center>
                    <el-step title="预约提交"></el-step>
                    <el-step title="预约待受理"></el-step>
                    <el-step title="预约已受理"></el-step>
                    <el-step title="预约受理完成"></el-step>
                </el-steps>
            </div> -->
      <div class="form">
        <el-form ref="form" v-model="detaile" label-width="200px">
          <el-form-item label="申请参观单位：">
            <el-input v-model="detaile.applydepname" readonly />
          </el-form-item>
          <el-form-item label="参观团成员姓名：">
            <el-input v-model="detaile.applyusers" readonly />
          </el-form-item>
          <el-form-item label="参观团成员人数：">
            <el-input v-model="detaile.visitpeoples" readonly />
          </el-form-item>
          <el-form-item label="参观申请方联系人：">
            <el-input v-model="detaile.applyusername" readonly />
          </el-form-item>
          <el-form-item label="联系人电话：">
            <el-input v-model="detaile.applyusertel" readonly />
          </el-form-item>
          <el-form-item label="校方接待部门：">
            <el-input v-model="detaile.recepdepname" readonly />
          </el-form-item>
          <el-form-item label="预约参观时间：">
            <el-input v-model="visittime" readonly />
          </el-form-item>
          <el-form-item label="申请备注：">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
              placeholder="请输入内容"
              v-model="detaile.memo"
              readonly
            />
          </el-form-item>
          <el-form-item label="邀请函/受邀凭证：" prop="pics">
            <el-row>
              <el-image
                v-for="(item, index) in pics"
                :key="index"
                :preview-src-list="pics"
                :src="item"
                style="width: 100px; height: 100px; padding: 10px 10px"
                :disabled="true"
              />
            </el-row>
          </el-form-item>
          <!-- <el-form-item
            label="预约批复："
            v-if="detaile.handlestate == 4 || detaile.handlestate == 3"
          >
            <el-row>
              <el-tag v-if="detaile.handlestate == 4" type="success"
                >申请批准</el-tag
              >
              <el-tag v-if="detaile.handlestate == 3" type="danger"
                >申请驳回</el-tag
              >
            </el-row>
          </el-form-item>
          <el-form-item
            label="申请批复附言："
            v-if="detaile.handlestate == 4 || detaile.handlestate == 3"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
              placeholder="请输入内容"
              v-model="detaile.handleopinion"
              :disabled="true"
            />
          </el-form-item> -->
        </el-form>
      </div>
    </div>
  </div>
</template>
  
<script>
//, mapGetters
import { mapActions } from "vuex";
import { Message } from "element-ui";
import { byidgedetail } from "@/api/SHMReservat";
import {fileAcquisition} from "@/config/net.config.js"
import moment from "moment";
export default {
  data() {
    return {
      detaile: "",
      pics: [],
      visittime: "",
      active: 0,
      finishstatus: "",
      loadingShow: true,
    };
  },
  mounted() {
    if (null == this.$route.query.id) {
      // this.messagetitle(false)
      // this.goBack()
    } else {
      this.getdetail(this.$route.query.id);
    }
  },
  methods: {
    //关闭当前标签页方法
    ...mapActions({
      delVisitedRoute: "tabs/delVisitedRoute",
    }),
    async goBack() {
      await this.delVisitedRoute();
      this.$router.go(-1);
    },
    messagetitle(val) {
      if (!val) {
        Message({
          message: "获取数据为空，确认id是否正确！",
          type: "error",
          showClose: true,
        });
      }
    },
    // formatTime(n) {
    //   //判断是否需要加0
    //   if (n < 10) {
    //     return "0" + n;
    //   } else {
    //     return n;
    //   }
    // },
    // gettime(time) {
    //   // console.log(time);
    //   var time1 = new Date(time);
    //   var y = time1.getFullYear();
    //   var m = time1.getMonth() + 1;
    //   var d = time1.getDate();
    //   var h = time1.getHours();
    //   var mm = time1.getMinutes();
    //   var s = time1.getSeconds();
    //   var time2 = new Date();
    //   var y2 = time2.getFullYear();
    //   var m2 = time2.getMonth();
    //   var d2 = time2.getDate();
    //   var date1 = y2 + "-" + m2 + "-" + d2 + " 00:00:00";
    //   var nowTime = new Date(date1.replace(/ /g, " "));
    //   date1 = nowTime.getTime();
    //   var T1 = date1;
    //   var T2 = T1 - 24 * 60 * 60 * 1000;
    //   var T3 = T2 - 24 * 60 * 60 * 1000;
    //   if (parseInt(time) > parseInt(T1)) {
    //     return `今天 ${this.formatTime(h)}:${this.formatTime(
    //       mm
    //     )}:${this.formatTime(s)} `;
    //   } else if (time >= T2 && time < T1) {
    //     return `昨天 ${this.formatTime(h)}:${this.formatTime(
    //       mm
    //     )}:${this.formatTime(s)}`;
    //   } else if (time >= T3 && time < T2) {
    //     return `前天 ${this.formatTime(h)}:${this.formatTime(
    //       mm
    //     )}:${this.formatTime(s)} `;
    //   } else {
    //     return `${y}-${this.formatTime(m)}-${this.formatTime(
    //       d
    //     )} ${this.formatTime(h)}:${this.formatTime(mm)}:${this.formatTime(s)} `;
    //   }
    // },
    async getdetail(id) {
      // this.$store.commit('setToken', this.token)
      const data = await byidgedetail(id);
      if (data.data != null) {
        this.detaile = data.data;
        this.visittime = moment(this.detaile.visittime).format('YYYY-MM-DD HH:mm:ss');
        if (this.detaile.handlestate == 1) {
          this.active = 2;
        } else if (this.detaile.handlestate == 2) {
          this.active = 3;
        } else if (
          this.detaile.handlestate == 3 ||
          this.detaile.handlestate == 4
        ) {
          this.active = 4;
        }
        this.loadingShow = false;
        if (data.data.pics != null && data.data.pics != "") {
          var list = JSON.parse(data.data.pics);
          list.forEach((item) => {
            this.pics.push(fileAcquisition+item.originalUrl);
          });
        }
      } else {
        // await this.delVisitedRoute()
        // this.$router.go(-1);
      }
    },
  },
};
</script>
  
<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-bottom: none;
  border-right: none;
}

.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-bottom: none;
  border-right: none;
}

.form {
  margin-left: 5%;
  border: 1px solid #dddddd;
  margin-top: 30px;
  padding: 20px;
  margin-right: 5%;
}

.steps {
  font-weight: bold;
  /* 下面 3 行代码设置子元素横竖均居中 */

  /*display: -webkit-flex;*/
  /* 设置水平居中 */
  justify-content: center;
  /* 设置垂直居中 */
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 100px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

.close {
  position: absolute;
  right: 0;
  font-size: 20px;
}

.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: white;
}

.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
  background-color: #008a2c;
}

.el-message-box {
  border: 2px solid #008a2c;
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  font-size: 18px;
  box-shadow: 0 2px 12px 0rgba (0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.el-message-box--center .el-message-box__header {
  padding-top: 15px;
}

.colseClass {
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.colseClass:hover,
.colseClass:focus {
  /* padding: 9px 15px; */
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}

.submitClass,
.submitClass:focus {
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.submitClass:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.cancelButtonClass {
  padding: 9px 15px;
  font-size: 12px;
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.cancelButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.confirmButtonClass,
.confirmButtonClass:focus {
  padding: 9px 15px;
  font-size: 12px;
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.confirmButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}
</style>